export default __webpack_public_path__ + "static/media/poster_astramed.512bef6c.jpg";